import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class RectifierTirGauche extends ActionCard {
    static typeId = "RECTIFIER_TIR_GAUCHE";
    static cardName = "Rectifier (Gauche)";
    static colorHex = "#FFAA00";
    static countInDeck = ACTION_CARD_COUNTS.RECTIFIER_TIR_GAUCHE;
    static description = "Déplacez une cible d’une case vers la gauche (si cet emplacement n’est pas déjà en joue).";

    isValidOn(slotIndex, gameState) {
        if (slotIndex === 0) return false;
        const hasTargetToken = gameState.lineOfFireSlots[slotIndex];
        const previousTargetHasToken = gameState.lineOfFireSlots[slotIndex - 1];

        // Can't move target to the left on last slot && targeted slot has a target token on it
        return hasTargetToken.isTargeted && !previousTargetHasToken.isTargeted;
    }

    resolve(slotIndex, gameState) {
        gameState.adjustShot(slotIndex, "left");
    }
}
